/**
 * Device client type enumeration
 */
export enum DeviceClientType
{
    Web = "Web",
    Android = "Android",
    iOS = "iOS"
}
